import classNames from "classnames";
import { Switch } from "react-router-dom";

import Statistics from "src/app/modules/admin/components/statistics/Statistics";
import AuthenticatedRoute from "src/app/modules/auth/AuthenticatedRoute";
import { ROLE, ROUTES } from "src/config/constants";

import adminCss from "./Admin.module.css";
import Projects from "./components/projects/Projects";
import Users from "./components/users/Users";

function Admin() {
  return (
    <div className={classNames(adminCss.container)}>
      <Switch>
        <AuthenticatedRoute path={ROUTES.adminProjects} roles={[ROLE.Admin, ROLE.RegionalAdmin]} component={Projects} />
        <AuthenticatedRoute path={ROUTES.adminUsers} roles={[ROLE.Admin]} component={Users} />
        <AuthenticatedRoute path={ROUTES.adminStatistics} roles={[ROLE.Admin]} component={Statistics} />
      </Switch>
    </div>
  );
}

export default Admin;
